import Layout from '@/layout';
var merchantRouter = {
  path: '/merchant',
  component: Layout,
  redirect: '/merchant/system',
  name: 'Merchant',
  meta: {
    title: '商户',
    icon: 'clipboard'
  },
  children: [{
    path: 'system',
    component: function component() {
      return import('@/views/merchant/system/index');
    },
    name: 'MerchantSystem',
    meta: {
      title: '商户平台管理',
      icon: ''
    }
  }]
};
export default merchantRouter;